import React from "react";
import BlockFooter from "../../../shared/components/BlockFooter/BlockFooter";
import { round } from "../../../../libraries/_helpers";
import PlayerRankedItem from "../PlayerRankedItem/PlayerRankedItem";
import LoadingDisplay from "../../../shared/components/LoadingDisplay";
import { useLeaderCard } from "../../utils";
import { useReactAppState } from "../../../shared/containers/utils";
import { trackPlayerClick } from "../../../../libraries/_modules/tracking/snowplow/trackPlayerInteraction";
import { trackClubClick } from "../../../../libraries/_modules/tracking/snowplow/trackClubInteraction";

function PlayerLeaderCardBody({ first, rest, clubData }) {
  const {
    footer,
    currentStatType,
    statTableUrl
  } = useLeaderCard();

  const { urlList, isLeague, clubSportecId, t } = useReactAppState();
  const { baseUrl } = urlList || {};
  const { player_first_name, player_last_name, team_short_name } = first || {};

  const backgroundColor = clubData?.backgroundColor || "";
  const roundedFirstStat = first && first[currentStatType] === 0 || first[currentStatType] ? round(first[currentStatType], 2) : "";
  const urlWithQueryParams = statTableUrl ? `${statTableUrl}?stat-type=${currentStatType}` : null;
  const isCurrentClub = first?.teamId == clubSportecId;
  const playerSlug = first?.playerSlug;

  const name = `${player_first_name} ${player_last_name}`;

  const handlePlayerClick = (e, playerData, position) => {
    e.preventDefault();
    
    trackPlayerClick({
      playerData: {
        player_id: playerData?.player_id,
        player_name: `${playerData?.player_first_name || ''} ${playerData?.player_last_name || ''}`.trim(),
        player_team: playerData?.team_short_name,
        jersey_number: playerData?.jersey_number
      },
      element_name: playerData?.playerSlug,
      element_type: "link",
      element_position: position
    });
    
    setTimeout(() => {
      window.location.href = e.currentTarget.href;
    }, 100);
  };

  const handleClubClick = (e, clubData, position) => {
    e.preventDefault();
    
    trackClubClick({
      clubData: {
        id: clubData?.sportecId,
        name: clubData?.fullName || clubData?.name,
        city: clubData?.city
      },
      element_name: clubData?.slug,
      element_type: "link",
      element_position: position
    });
    
    setTimeout(() => {
      window.location.href = e.currentTarget.href;
    }, 100);
  };

  return (
    <div className="d3-o-media-object__body">
      <div style={backgroundColor ? { backgroundColor } : {}} data-testid={"rank-1"} className="d3-o-media-object__rank d3-o-media-object__rank--top">
        <div className="d3-o-media-object__name-wrapper">
          {
            isLeague || isCurrentClub ?
              <div className="d3-o-media-object__name">
                {playerSlug ? 
                  <a 
                    alt={name} 
                    href={`${baseUrl}/players/${playerSlug}`} 
                    className="d3-o-media-object__name--link"
                    onClick={(e) => handlePlayerClick(e, first, "leader-card-top")}
                  >
                    {name}
                  </a> : name}
              </div> :
              <div className="d3-o-media-object__name">{name}</div>
          }
          {
            isLeague ?
              <div className="d3-o-media-object__club-name">
                <a 
                  alt={team_short_name} 
                  href={`${baseUrl}/clubs/${clubData?.slug}`} 
                  className="d3-o-media-object__club-name--link"
                  onClick={(e) => handleClubClick(e, clubData, "leader-card-top-club")}
                >
                  {team_short_name}
                </a>
              </div> :
              <div className="d3-o-media-object__club-name">{team_short_name}</div>
          }
        </div>
        <div className="d3-o-media-object__stat">{roundedFirstStat}</div>
      </div>
      <div className="d3-o-media-object__ranked-list">
        {
          rest?.map((player, index) => {
            return player
              ? <PlayerRankedItem key={player.player_id} index={index} item={player} statType={currentStatType} />
              : <LoadingDisplay key={index} />
          })
        }
      </div>
      {
        statTableUrl
          ? <BlockFooter iconSize="small" link={urlWithQueryParams} title={`${t("leader_card_full")} ${footer} ${t("leader_card_list")}`} />
          : null
      }
    </div>
  );
}

// eslint-disable-next-line no-func-assign
PlayerLeaderCardBody = React.memo(PlayerLeaderCardBody);

export default PlayerLeaderCardBody;
